module.exports = __webpack_public_path__ + "img/bornutti5.a1d619f7.jpg";